import {
  ReportStatus,
  SortCriteria,
  SortCriteriaField,
  SortOrder,
} from '@amzn/coral_com-amazon-transreportscenterservice';
import { getTimeZone } from '../utils/dateUtils';
import invert from 'lodash/invert';
import { REPORTS_LIST_PATH } from './routes';

export const DEFAULT_SORT_CRITERIA = SortCriteria.clone({
  sortField: SortCriteriaField.LAST_UPDATED_TIME,
  sortOrder: SortOrder.DESC,
});

export const TABLE_SORT_DIRECTION_SORT_ORDER_MAP = {
  ascending: SortOrder.ASC,
  descending: SortOrder.DESC,
};

export const INVERTED_TABLE_SORT_DIRECTION_SORT_ORDER_MAP = invert(
  TABLE_SORT_DIRECTION_SORT_ORDER_MAP
);

export const TABLE_SORT_COLUMN_SORT_ORDER_MAP = {
  lastUpdatedTime: SortCriteriaField.LAST_UPDATED_TIME,
  reportRecordLastUpdatedTime:
    SortCriteriaField.REPORT_RECORD_LAST_UPDATED_TIME,
  recordCreationTime: SortCriteriaField.REPORT_RECORD_CREATION_TIME,
};

export const INVERTED_TABLE_SORT_COLUMN_SORT_ORDER_MAP = invert(
  TABLE_SORT_COLUMN_SORT_ORDER_MAP
);

export const TABLE_COLUMNS_TYPE_TIME = ['lastUpdatedTime', 'creationTime'];
export const TABLE_COLUMNS_TYPE_STATUS = ['reportStatus'];
export const TABLE_COLUMNS_SORATABLE = ['lastUpdatedTime'];

export const TABLE_COLUMN_TYPE_TIME_HEADER_SUFFIX = ` (${getTimeZone()})`;

// Default columns as fallback
export const TABLE_COLUMNS = [
  {
    columnDisplayName: 'reports_list_page.report_name',
    valuePathStructure: 'reportName',
  },
  {
    columnDisplayName: 'reports_list_page.published_on',
    valuePathStructure: 'lastUpdatedTime',
  },
];

export const LP_DROPDOWN_ALLOWED_PATHS = [REPORTS_LIST_PATH];

export const REPORT_STATUSES = Object.keys(ReportStatus).filter(
  (status: string) =>
    ![
      ReportStatus.PENDING,
      ReportStatus.PUBLISHED,
      ReportStatus.INGESTION_PENDING,
      ReportStatus.APPROVAL_CREATED,
    ].includes(status)
);
